import { render, staticRenderFns } from "./ChipUser.vue?vue&type=template&id=5296666b"
import script from "./ChipUser.vue?vue&type=script&lang=js"
export * from "./ChipUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports